function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12 2C6.477 2 2 6.5 2 12.051c0 5.04 3.693 9.2 8.505 9.928v-7.264H8.031v-2.642h2.474v-1.758c0-2.91 1.411-4.188 3.818-4.188 1.153 0 1.762.085 2.051.125v2.306h-1.642c-1.022 0-1.378.974-1.378 2.071v1.444h2.994l-.406 2.642h-2.588V22c4.88-.666 8.646-4.86 8.646-9.949C22 6.501 17.523 2 12 2z"
});

function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgFacebookinline;